import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";
import ClientsCard from "./ClientsCard";
import useSession from "../../hooks/useSession";

const HomeClients = () => {
  const { clientsApi } = apiPath;
  const [clients, clientsLoading] = useFetch(clientsApi);
  const [user] = useSession();

  if (clientsLoading) {
    return <Loading />;
  }

  const { sectionName, sectionSlogan, clientsList, _id } = clients;

  const data = [
    {
      elementType: "input",
      label: "Section Name",
      type: "Text",
      name: "sectionName",
      defaultValue: sectionName,
      required: true,
    },
    {
      elementType: "textField",
      label: "Section Slogan",
      type: "Text",
      name: "sectionSlogan",
      defaultValue: sectionSlogan,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(clientsApi, data);
  };

  return (
    <div>
      <div className="container mx-auto pt-12 px-5 lg:px-16 -mb-8 lg:-mb-20">
        <h2 className="font-semibold text-2xl">Section Details:</h2>
      </div>
      <GlobalForm
        data={data}
        // multiDimensionalDataImage={multiDimensionalDataImage}
        update={update}
      />
      <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16">
        <h2 className="font-semibold text-2xl mb-4">Clients List:</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          <ClientsCard />
          {clientsList.map((project, index) => (
            <ClientsCard
              key={index}
              project={project}
              user={user.role}
              indexId={_id}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeClients;
